import React from 'react';
import Event from './Event';

const Events = ({ groups, showMyStudentsOnly }) => {
  const staffMember = localStorage.getItem('user');

  const filteredGroups = showMyStudentsOnly
    ? Object.entries(groups).reduce((obj, [group, events]) => {
        const filteredEvents = events.filter((event) =>
          event?.staff_members.some((staff_member) => staff_member.name === staffMember)
        );
        if (filteredEvents.length > 0) {
          obj[group] = filteredEvents;
        }
        return obj;
      }, {})
    : groups;

  Object.keys(filteredGroups).forEach((group) => {
    filteredGroups[group].sort((a, b) => {
      const aStart = new Date(a.start_at);
      const bStart = new Date(b.start_at);
      return aStart - bStart;
    });
  });

  return (
    <div>
      {Object.keys(filteredGroups).map((group) => (
        <div key={group} className="mb-6 pb-6">
          <h1 className="text-3xl font-semibold pb-4 text-slate-900 dark:text-white text-center sm:text-left">
            {group}
          </h1>
          <div className="gap-6 grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-4">
            {filteredGroups[group].map((event) => (
              <Event key={event.id} event={event} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Events;
